// 会员协议
let user = {
  title: '云柑社区用户协议',
  content:[
    {
      text: '协议的版本及生效日期',
      subText: [
        {
          text: '《云柑社区用户协议》于2019年2月1日起生效，最新版本更新时间：2021年7月26日。'
        }
      ]
    },
    {
      text: '欢迎您使用云柑社区!',
      subText: [
        {
          text: '“云柑社区”，定位于一个有文化温度的社区，使用5G、人工智能、区块链、大数据等高新技术，集成了云柑社区、云柑访客、云柑名片、云柑5G云店、云柑组织等应用服务，为数字乡村/生活社区等打造乡村数字化、城乡融合、同镇生活圈、社区网格化服务的社区数字生态平台（以下统称为“本平台”），赋能乡村振兴和城乡融合。了解和熟悉产品的功能和设置，并根据自身情况进行设置调整，避免发生您的信息被滥用，是您自己的责任。我们欢迎您向我们反馈使用体验和改进隐私保护与产品需求/用户需求之间的平衡的可操作性建议。'
        },
        {
          text: ' 感谢您选择“云柑社区”，《云柑社区用户协议》是由惠州市脉链科技有限公司（以下简称“我们”）与您签订，“您”是指“云柑社区”的使用者。'
        },
        {
          text: '请您仔细阅读以下条款，如果您对本协议的任何条款表示异议，您可以选择不进入“云柑社区”。当您注册成功，无论您是否使用“云柑社区”的服务和数据，均意味着您完全接受本协议项下的全部条款，本协议内容不受其他国家或地区的排斥。'
        },
        {
          text: '若您不具备前述条件或对本协议的任何条款有异议，请停止使用“云柑社区”所提供的全部服务。'
        }
      ]
    },
    {
      text: '一、账户注册、使用及安全',
      subText: [
        {
          text: '1、注册者资格',
          subText: [
            {
              text: '（1）在您完成注册程序之前，请确认您是具备完全民事权利能力和完全民事行为能力的自然人、法人或其他组织。若您不具备前述主体资格，您应承担因此而导致的一切后果，且“云柑社区”有权注销或永久冻结您的账户，并向您索偿。'
            },
            {
              text: '（2）无民事行为能力人和限制民事行为能力人确因特殊情况需要注册账号的，应和“云柑社区”客服联系并提交相关证明进行申请，但“云柑社区”有权不予同意。'
            },
            {
              text: '（3）未成年者谢绝使用。'
            }
          ]
        },
        {
          text: '2、您承诺，在注册账户时提供真实的信息，并愿意承担由于提供虚假信息对您造成的不利后果以及对我们或第三方造成的任何损失。在您申请开通某些平台服务时，我们会对您的真实身份进行核实，您承诺将积极地予以配合，否则您将无法使用这些平台服务。'
        },
        {
          text: '3、请您妥善保管您的账户密码，并承担该账户项下所有活动产生的全部责任。我们特别提醒您应采取特定措施保护您的账户的安全，包括但不限于妥善保管账户密码、安装防病毒木马软件、定期更改密码、使用后安全退出等。如您账户和密码被盗用，除非您能证明该事件是由于我们的故意或重大过失直接导致，否则您应承担账号被盗用期间产生的一切责任和后果。'
        },
        {
          text: '4、您的账户只限于您本人使用，请勿与他人共用您的账户，否则，我们将无法保证您的数据安全。您了解并同意，使用您的账户实施的任何行为都视为您的行为，即使是他人使用您的账户实施的行为，您也将承担连带责任。如果您发现有人未经授权使用了您的账户，请立即联系并通知我们。除非有法律法规规定，或者符合本平台公布的条件，否则您的账户名、昵称和密码不得以任何方式转让、赠与或继承，并且转让、赠与或继承需提供本平台要求的合格的文件材料并根据本平台制定的操作流程办理。'
        },
        {
          text: '5、特别提醒：鉴于手机号码通常绑定较多功能并且经常作为辅助识别验证身份的工具，一旦您的手机号码发生变化，请您务必及时进行账户相关内容的修改，以免发生他人盗用您的手机号码验证身份。用于验证身份的Email若发生安全问题也应参照前述提醒进行预防、处置。'
        }
      ]
    },
    {
      text: '二、隐私与个人信息',
      subText: [
        {
          text: '1、我们尊重用户的个人隐私，并依照法律对您的隐私和个人信息进行保护。鉴于互联网社交服务的特性，您在注册账户或使用我们的服务时所提供的信息可能会被默认设置为公开状态，对于您不希望被公开的信息，请根据您的需求调整相关隐私设置，以避免相关风险。在账号注册时，如果允许我们获取您的微信信息，我们将获取您的微信头像、昵称进行注册登录。'
        },
        {
          text: '2、您理解并承诺，对您了解、接收或可接触到的其他用户和包括您上传的资料信息中涉及的他人隐私和未公开信息予以充分尊重，未经许可，不得搜集、复制、存储、传播、散播、滥用他人隐私和未公开信息。用户使用本平台各项功能时应充分尊重人的生活安宁权，不滥用个人信息，不影响他人电话、邮件等正常使用，若您恶意使用他人个人信息及未公开信息，或者以任何方式侵害他人的隐私及未公开信息的（包括但不限于对其他用户造成骚扰），我们将随时限制或者终止您的账户的权限甚至删除账户，保留随时单方面终止服务协议并追究您法律责任的权利。'
        },
        {
          text: '3、您知悉并同意，本平台及关联公司可能为以下需要保留、保存或披露您的个人信息：',
          subText: [
            {
              text: '（1）遵守适用的法律法规；',
            },
            {
              text: '（2）遵守法院命令或其他法律程序的规定；',
            },
            {
              text: '（3）遵守相关政府机关的要求；',
            },
            {
              text: '（4）本平台认为为遵守适用的法律法规、维护社会公共利益、或保护本平台运营方、本平台其他用户或雇员的人身和财产安全或合法权益所合理必需的。',
            }
          ]
        },
      ]
    },
    {
      text: '三、按现状提供服务',
      subText: [
        {
          text: '我们的服务是按照现有技术和条件所能达到的现状提供的。我们会尽最大努力向您提供令人满意的服务，确保服务的连贯性和安全性，但我们不能随时预见和防范法律、技术以及其他风险，包括但不限于不可抗力、病毒、木马、黑客攻击、系统不稳定、第三方服务瑕疵、政府行为等原因可能导致的服务中断、数据丢失以及其他的损失和风险。您明确理解和同意，使用我们的服务由您自行承担风险。'
        },
        {
          text: '1、“云柑社区”服务的具体内容由“云柑社区”系统根据实际情况提供，包括但不限于授权您通过您的个人账户在本平台上聊天、评论、发送图片或视频、转发链接等。'
        },
        {
          text: '2、您在本平台使用过程中与其他用户或第三方发生纠纷，除依本协议约定可向本平台举报的侵权内容外，其他纠纷应由您双方或各方协商或通过其他方式解决，本平台不承担相关责任。'
        },
        {
          text: '3、您可自行编辑注册信息中的账户名称、昵称、头像、简介等（以下简称“账户信息”），但应遵守法律法规及相关管理规定，不得含有违法和不良信息。同时，',
          subText: [
            {
              text: '（1）请勿注册和使用易产生歧义、引起他人误解的昵称。'
            },
            {
              text: '（2）您以虚假信息骗取账号名称注册，或账号头像、简介等注册信息存在违法和不良信息的，本平台有权暂停或注销该账户。'
            }
          ]
        },
        {
          text: '4、未经相关权利人授权，您不得以他人或其他组织机构名义注册“云柑社区”账户，亦不得使用引人误解的账户信息注册“云柑社区”账户，包括但不限于让人误认为该账户与某社会名人或机构组织存在关联关系的名称、头像或简介等。您须对本平台注册信息的真实性、合法性、有效性承担全部责任；不得利用他人的名义发布任何信息；不得恶意使用注册账户导致其他用户误认。否则“云柑社区”有权立即停止提供服务，收回其账户并由您独自承担由此而产生的一切法律责任。'
        },
        {
          text: '5、您同意本平台在提供服务过程中以各种方式投放各种商业性广告或其他任何类型的商业信息（包括但不限于在本平台网站的任何页面上投放广告）。在您使用我们的服务时，您可能会收到推送信息，这些推送信息包括我们的产品或服务的更新内容以及可能对您有用的关于第三方产品或服务的信息等。我们特别提醒您，如果您收到的推送信息是关于第三方而非我们的，对于此类信息，您应当自行判断其内容的真实性并为自己的判断行为负责。除法律明确规定外，您因此类信息提供的内容而遭受的任何损失或损害，我们均不承担任何责任。'
        },
        {
          text: '6、您在本平台上传或发表的内容，您应保证您为著作权人或已取得合法授权，并且该内容不会侵犯任何第三方的合法权益。如果第三方提出关于著作权的异议，本平台有权根据实际情况删除相关的内容，且有权追究您的法律责任。给本平台或任何第三方造成损失的，您负责全额赔偿。'
        },
        {
          text: '7、如果任何第三方侵犯了您使用在本平台获得的权利，您同意授权"云柑社区"或其指定的代理人代表本平台自身或您对该第三方提出警告、投诉、发起行政执法、诉讼、进行上诉，或谈判和解，并且您同意在本平台认为必要的情况下参与共同维权。'
        },
        {
          text: '8、本平台将对您发布的内容进行审查和监督，对于不符合本协议规定的内容，经审核后将不予发布。如您在使用本平台时违反任何上述规定发布内容，本平台有权要求您改正或直接根据相关证据结合《侵权责任法》、《信息网络传播权保护条例》等法律法规对违法、侵权信息进行处理（包括但不限于更改或删除您发布的内容、暂停或终止您使用“云柑社区”的权利）以减轻您不当行为造成的影响。'
        },
        {
          text: '9、您可以在本平台的云柑社区云店购买商品或服务，您已知悉，知识类商品一经售出，不得退换，服务类商品的售后分为随时退（未消费可以随时退款）、过期退（使用期限过后自动退款）、不可退三种，具体以店家发布时选择的售后类型为准。'
        }
      ]
    },
    {
      text: '四、用户产生的内容',
      subText: [
        {
          text: '您对您上传到您的账户中的合法内容依法享有著作权或其他权利。'
        },
        {
          text: '任何经由您的账户发送、上传、张贴、发布的内容（包括但不限于名片信息、通讯录、地理位置、电子邮件、消息、资料、文字作品、软件、音乐、录音制品、照片、图形、视频、数据、用户的登记信息或其他信息等，以下简称“内容”），无论是公开还是私下传送，均由内容提供者承担责任，您保证已拥有必要授权上传内容。若因您的行为导致我们的损失（包括但不限于赔偿、律师费），您同意对该损失承担全部赔偿责任。因故意发布的内容侵犯第三方权益或者涉及违法犯罪遭到查处，导致"云柑社区"产品商誉受到损害的，应予赔偿商誉损失。我们保留依法对内容进行审核、屏蔽、删除或终止服务的权利。'
        },
        {
          text: '您可以在本平台上添加系统未有的社区，但不代表您是该社区的运营商，您与该社区不存在任何从属关系。'
        },
        {
          text: '关于公开内容，您同意许可"云柑社区"在全球范围内享有免许可费、非独家的、可再许可及永久有效的使用权利。我们可以自行决定使用（包括但不限于复制、改编、修改、创建衍生作品、翻译）、传播这些内容。同时您许可"云柑社区"有权就任何第三方对上述内容或其衍生品的侵权以自己名义提起诉讼，并获得全部赔偿。您保证已拥有必要授权对"云柑社区"进行此许可。'
        },
        {
          text: '虽有前款保留权利之约定，但不代表我们一定会进行上述使用、传播行为，且此权利保留仅针对您已公开的内容，不涉及个人未公开信息和隐私。'
        }
      ]
    },
    {
      text: '五、所有权及知识产权',
      subText: [
        {
          text: '您了解并同意，"云柑社区"平台拥有平台服务的一切合法权利，包括我们的软件和服务的所有权及知识产权。'
        },
        {
          text: '我们的服务中的信息内容包括但不限于：文字、软件、音视频文件、相片以及图表等。我们的服务中的信息内容受著作权法、专利法、商标法及其它所有相关法律法规的保护。您只能在获得我们的授权时才能使用这些内容，而不能擅自复制、修改、编撰这些内容、或创造与内容有关的衍生产品。除非您与我们另行达成书面协议，否则本协议未授权您使用"云柑社区"相关的任何软件名称、商标、服务标记、徽标、域名和其它有显著品牌特征的标识。'
        }
      ]
    },
    {
      text: '六、用户行为规范',
      subText: [
        {
          text: '1、您在使用我们的服务时应遵守当地有关的法律和法规，不得制作、复制、发布、传播敏感信息、违法信息或普通人会视为违反道德的任何信息或材料，包括但不限于下列信息：',
          subText: [
            {
              text: '（1）反对宪法所确定的基本原则的；'
            },
            {
              text: '（2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；'
            },
            {
              text: '（3）损害国家荣誉和利益的；'
            },
            {
              text: '（4）煽动民族仇恨、民族歧视，破坏民族团结的；'
            },
            {
              text: '（5）破坏国家宗教政策，宣扬邪教和封建迷信的；'
            },
            {
              text: '（6）散布谣言，扰乱社会秩序，破坏社会稳定的；'
            },
            {
              text: '（7）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；'
            },
            {
              text: '（8）侮辱或者诽谤他人，侵害他人合法权益的；'
            },
            {
              text: '（9）含有法律、行政法规禁止的其他内容的。'
            },
            {
              text: '（10）其他违反《中华人民共和国网络安全法》的内容。'
            }
          ]
        },
        {
          text: '2、您不得为任何非法目的而使用我们的服务，不得利用我们的服务从事违法行为，包括但不限于：',
          subText: [
            {
              text: '（1）利用我们的服务从事任何可能对互联网的正常运行造成不利影响的行为；'
            },
            {
              text: '（2）盗取或非法访问、滥用其他用户的账户或账户内的信息；'
            },
            {
              text: '（3）恶意虚构事实、隐瞒真相以误导、欺骗他人；'
            },
            {
              text: '（4）发表、传送、传播广告信息及垃圾信息，发起、延续或以任何形式参与任何投机或其它非法的计划，或利用电话、网络等通讯方式骚扰他人；'
            },
            {
              text: '（5）发布、传送、传播、储存侵害他人知识产权、商业秘密等合法权益的内容；或传送或散布以其他方式实现传送含有受到知识产权法律保护的图像、相片、软件或其他资料的文件，除非您拥有相应的权利、授权或已得到所有必要的认可；'
            },
            {
              text: '（6）其他法律法规禁止的行为。'
            }
          ]
        },
        {
          text: '3、您不得从事任何妨害“云柑社区”合法权益的行为，除非法律明确允许或“云柑社区”书面许可，您在使用我们的服务时不得从事本协议未明示授权的一切行为，包括但不限于：',
          subText: [
            {
              text: '（1）删除我们的服务中所有关于著作权的信息；'
            },
            {
              text: '（2）对我们的服务中的信息（包括但不限于使用我们的服务时存储到任何终端设备中的信息及客户端与服务器端的交互信息等）进行商业性复制、或更改、修改、挂接运行或创作任何衍生作品或产品，形式包括但不限于使用插件、外挂或非经授权的第三方工具/服务接入、干扰、影响我们的软件和相关系统；'
            },
            {
              text: '（3）限制、禁止或用其它方法干涉、影响他人使用或享有我们的服务（家长控制之类的安全和保护工具除外），包括但不限于发布或传输以下性质的任何信息或软件：包含蠕虫、病毒或其它有害功能，或生成的流量级别可能妨碍其他人使用、发送或检索信息；'
            },
            {
              text: '（4）通过任何自动方式访问（或尝试访问）我们的服务；'
            },
            {
              text: '（5）对我们的服务中的相关信息内容等进行商业性使用、出租、出借、复制数据、修改、链接、转载、汇编、发表、出版、建立镜像站点等；'
            },
            {
              text: '（6）出于操纵或扭曲目的而进行的任何操作、评级或评论，或者可能影响我们的服务的完整性或准确性的任何行为。'
            },
            {
              text: '（7）其他未经“云柑社区”明示授权的行为。'
            }
          ]
        },
        {
          text: '4. 如果您实施了前款规定的行为，您应当独立为此承担相应责任，我们不承担任何责任。由此造成损害的，您应依法予以赔偿，我们将保留依法追偿损失及赔偿的权利。'
        },
        {
          text: '5. 因为您违反本协议规定的行为而对"云柑社区"及其关联公司造成的损失，包括但不限于因您的行为导致或产生的任何第三方主张的任何索赔、要求或损失，以及我们处理这些事务的必要支出，例如律师费等，您同意赔偿“云柑社区”的上述损失，并使之免受损害。除非另有明确的书面说明,“云柑社区”不对本软件的运营及其包含在本软件上的信息、内容、材料、产品（包括软件）或服务作任何形式的、明示或默示的声明或担保（根据中华人民共和国法律另有规定的以外）。'
        },
        {
          text: '6、如使用本平台创建群组或社群，群组中的群主和群管理员以及社群中的社群主和社群管理员须对群里发布的内容承担相应的法律责任，确保群成员发布的内容符合国家法律法规的要求。'
        }
      ]
    },
    {
      text: '七、责任限制',
      subText: [
        {
          text: '1、请您从我们提供的官方途径创建您的账户和使用我们的服务，否则，我们无法保证您的账户的安全性。对于因使用未经授权的账户对您或第三方造成的损失，我们不承担任何责任。'
        },
        {
          text: '2、请您正确使用您的账户，您也可以直接联系我们，以获取必要的帮助，因您设置或操作不当造成的损失由您自行承担。'
        },
        {
          text: '3、您完全理解，您的账户涉及互联网服务，可能会遇到各种不可抗力等风险因素，使相关服务发生中断。我们将努力及时修复，但是由此给您造成的一切损失须自行承担，我们不予负责。这些意外风险包括但不限于如下原因导致的服务中断和受阻：',
          subText: [
            {
              text: '（1）受到计算机病毒、木马或其他恶意程序、黑客攻击的破坏；'
            },
            {
              text: '（2）用户或我们的终端设备软件、系统、硬件和通信线路出现故障；'
            },
            {
              text: '（3）意外事件、自然灾害或政府行为；'
            },
            {
              text: '（4）用户使用非经我们提供或授权提供的服务；'
            },
            {
              text: '（5）其他不可抗力或我们无法控制的因素。'
            }
          ]
        },
        {
          text: '4、我们对无法合理预知和不可控制的产品技术瑕疵、服务的稳定性以及由此产生的任何损失或损害不作任何形式的担保，但法律法规另有规定的除外。'
        },
        {
          text: '5、若您的账户在不能正常使用期间产生任何直接或间接损失，我们不承担任何直接或间接的法律责任。'
        },
        {
          text: '6、在通过云柑社区云店购买知识或服务类商品前，请您仔细考虑购买的必要性，如在运用或使用商品的过程中受到伤害，云柑社区平台不承担相关责任。'
        }
      ]
    },
    {
      text: '八、服务的修改、中断、中止与终止',
      subText: [
        {
          text: '1、您可以随时终止使用我们的服务，同时注销您的账户。'
        },
        {
          text: '2、如发生下列任何一种情形，我们有权不经通知而中断或终止向您提供我们的服务：',
          subText: [
            {
              text: '（1）您提供的个人信息不准确，不真实或不合法有效；'
            },
            {
              text: '（2）您违反本协议的规定；'
            },
            {
              text: '（3）按照法律规定或主管部门的要求；'
            },
            {
              text: '（4）其他必要的情形。'
            }
          ]
        },
        {
          text: '3、您的账户被注销后，您的账户下的信息将被彻底删除，且我们不再对您承担任何义务。'
        }
      ]
    },
    {
      text: '九、法律适用与管辖',
      subText: [
        {
          text: '因本协议的成立、生效、履行或与之有关的解释及纠纷的解决，适用于中华人民共和国大陆地区法律（不包括冲突法）；若您和本平台之间发生任何纠纷或争议，首先应友好协商解决；协商不成的，您同意纠纷或争议由本平台注册地法院管辖。'
        },
        {
          text: '本协议的所有条标仅仅是为了醒目及阅读方便，本身并无实际涵义，不能作为本协议涵义解释之依据。如果本协议中任何一条被视为废止、无效或因任何理由不可执行，该条应视为可分的且并不影响任何其余条款的有效性和可执行性。'
        }
      ]
    },
    {
      text: '十、其他',
      subText: [
        {
          text: '我们欢迎您就我们的服务提出反馈，除非另有明确声明，您发送的任何反馈内容将被视为无需保密的内容，您同意我们可以自行决定是否公开、发表，您同意授权我们无偿使用，并可以根据具体情况进行修改、改编、调整设计、变更技术方案，或者根据我们的需求进行其他改动。'
        },
        {
          text: '如果您对我们的服务或本用户协议有任何意见或建议，可通过客服与我们联系，我们会尽可能的给予您及时而必要的帮助。'
        },
        {
          text: '本协议解释权及修订权归“云柑社区”所有。本协议内容请您认真阅读。您注册后即视为您完全接受本协议，在注册之前请您再次确认已知悉并完全理解本协议的全部内容。'
        },
        {
          text: '根据国家法律法规变化及平台运营需要，“云柑社区”有权以公告的方式进行不定期地制定、修改本协议或相关服务规则，暂停、取消和修改本协议条款，修改后的协议一旦被公告在平台上即生效，并代替原来的协议。用户应及时关注不时发布的各项服务规则及本协议的变更。若不同意相关规则及条款修改的，应及时终止与本平台的协议。如用户继续使用本平台服务，即视为同意更新后的协议。'
        }
      ]
    }
  ]
}
export default user
